<template>
  <fieldset>
    <div class="tags" v-if="value.length">
      <t-tag
        v-for="item in value"
        :key="item"
        class="button"
        type="plain"
        closeable
        small
        @close="handleRemove(item)"
      >
        {{ item }}
      </t-tag>
    </div>
    <t-input v-model="inputValue" />
    <t-button soft :disabled="disableButton" @click="handleAdd">
      <t-icon icon="plus" slot="left" />
      {{ $t(buttonLabelKey) }}
    </t-button>
  </fieldset>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: false,
      default: () => [],
    },

    buttonLabelKey: {
      type: String,
      required: false,
      default: 'global.actions.add',
    },
  },

  data: () => ({
    inputValue: '',
  }),

  computed: {
    disableButton() {
      return !this.inputValue || this.value.includes(this.inputValue);
    },
  },

  methods: {
    handleAdd() {
      this.$emit('input', [...this.value, this.inputValue]);
      this.$emit('change', [...this.value, this.inputValue]);
      this.inputValue = '';
    },

    handleRemove(tag) {
      const filteredArray = this.value.filter((item) => item !== tag);
      this.$emit('input', filteredArray);
      this.$emit('change', filteredArray);
    },
  },
};
</script>

<style lang="scss" scoped>
.tags {
  margin-top: $s-6;
  display: flex;
  gap: $s-2;
  flex-wrap: wrap;
}
</style>
